import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material";
import { Visibility } from '@mui/icons-material';

import AlertResponse from "../../../../shared/general/AlertResponse";
import ButtonBlue from "../../../../shared/general/ButtonBlue";

import Paper from "@mui/material/Paper";
import DialogContract from "./DialogContract";

const StyledWrapBranch = styled("div")({
  marginBottom: 36,
  "& .wrap-branch-top": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
    "& .MuiTypography-body2": {
      margin: 0,
    },
  },
  "& .branch-scroll": {
    height: 280,
    overflow: "auto",
  },
  "& .action": {
    textAlign: "right",
    "& .fal": {
      fontSize: 18,
    },
  },
  "& .address": {
    fontWeight: 600,
    fontSize: 18,
  },
  "& .contact": {
    "& .fal": {
      marginRight: 8,
    },
  },
});

const StyledHeadLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 14,
});

function createData(start, end, type, file, status) {
  return { start, end, type, file, status };
}

const EmploymentContract = () => {
  const { t, i18n } = useTranslation();
  const { result: employeeProfile } = useSelector(
    (state) => state.employeeProfile
  );
  const [openContract, setOpenContract] = useState(false);
  const [idContract, setIdContract] = useState(null);
  const [typeDialog, setTypeDialog] = useState("Add");
  const [alertStatus, setAlertStatus] = useState({
    isOpen: false,
    type: null,
    label: null
  });

  const handleOpenContract = (type, idCont) => {
    if (type === "Add") {
      setTypeDialog("Add");
    } else {
      setTypeDialog("Edit");
    }
    if (idCont) {
      setIdContract(idCont);
    }
    setOpenContract(true);
  };

  const handleClose = () => {
    setOpenContract(false);
    setIdContract(null);
  };

  return (
    <div>
      <StyledWrapBranch>
        <div className="wrap-branch-top">
          <StyledHeadLabel variant="body2" gutterBottom>
            {t("employeeContract")}
          </StyledHeadLabel>
          <div>
            <ButtonBlue
              style={{ marginRight: 8 }}
              size="small"
              variant="contained"
              onClick={() => handleOpenContract("Add")}
            >
              {t("addEmployeeContract")}
            </ButtonBlue>
          </div>
        </div>
        <TableContainer component={Paper} style={{ boxShadow: "none" }}>
          <Table style={{ minWidth: 600 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">{t("StartDate")}</TableCell>
                <TableCell align="center">{t("EndDate")}</TableCell>
                <TableCell align="center">{t("Employee_Type")}</TableCell>
                <TableCell align="center">{t("AttachFile")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(employeeProfile && employeeProfile.contract && employeeProfile.contract.length > 0) ? 
              employeeProfile.contract.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="center">
                    {dayjs(row.startDate)
                      .locale(localStorage.getItem("language") || "th")
                      .format(
                        localStorage.getItem("language") === "th"
                          ? "DD MMM BBBB"
                          : "DD MMM YYYY"
                      )}
                  </TableCell>
                  <TableCell align="center">
                    {dayjs(row.endDate)
                      .locale(localStorage.getItem("language") || "th")
                      .format(
                        localStorage.getItem("language") === "th"
                          ? "DD MMM BBBB"
                          : "DD MMM YYYY"
                      )}
                  </TableCell>
                  <TableCell align="center">{row.employeeTypeName}</TableCell>
                  <TableCell align="center">
                    <ButtonBlue
                      onClick={() => {
                        window.open(row.fileURL, "_blank");
                      }}
                    >
                      ดูไฟล์
                    </ButtonBlue>
                  </TableCell>
                </TableRow>
              ))
              :
              (
                <TableRow>
                  <TableCell align="center" colSpan={4}>
                    <Typography align="center"> ไม่พบสัญญา</Typography>
                  </TableCell>
                </TableRow>
              )
              }
            </TableBody>
          </Table>
        </TableContainer>
      </StyledWrapBranch>
      {openContract && (
        <DialogContract
          open={openContract}
          handleClose={handleClose}
          idEmployeeContract={idContract}
          type={typeDialog}
          setAlertStatus={setAlertStatus}
        />
      )}
      {alertStatus.isOpen &&
        <AlertResponse 
          open={alertStatus.isOpen}
          handleClose={() => {
            setAlertStatus({
              isOpen: false,
              type: null,
              label: null
            })
          }}
          alertType={alertStatus.type}
          label={alertStatus.label}
        />        
      }
    </div>
  );
};

export default EmploymentContract;
